import { apiClient, apiGet, apiPost, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

const BASE = "/search";

export const searchApi = {
  search: (params: {
    q?: string;
    type?: string;
    category?: string;
    tags?: string[];
    page?: number;
    limit?: number;
    sort?: "relevance" | "date" | "title";
    order?: "asc" | "desc";
    filters?: Record<string, string>;
  }) => {
    const searchParams = new URLSearchParams();
    if (params.q) searchParams.set("q", params.q);
    if (params.type) searchParams.set("type", params.type);
    if (params.category) searchParams.set("category", params.category);
    if (params.tags?.length) searchParams.set("tags", params.tags.join(","));
    if (params.page) searchParams.set("page", String(params.page));
    if (params.limit) searchParams.set("limit", String(params.limit));
    if (params.sort) searchParams.set("sort", params.sort);
    if (params.order) searchParams.set("order", params.order);
    if (params.filters) {
      Object.entries(params.filters).forEach(([key, value]) => {
        searchParams.set(`filter.${key}`, value);
      });
    }
    return apiGet<{ results: Record<string, unknown>[]; total: number; facets?: Record<string, Record<string, number>>; took: number }>(
      `${BASE}?${searchParams.toString()}`
    );
  },

  getSuggestions: (q: string) => {
    if (!q || q.length < 2) return Promise.resolve({ suggestions: [] });
    const searchParams = new URLSearchParams();
    searchParams.set("q", q);
    searchParams.set("limit", "8");
    return apiGet<{ suggestions: Array<{ id: string; title: string; description: string; type: string; url: string }> }>(
      `${BASE}/suggestions?${searchParams.toString()}`
    );
  },

  getStats: () => apiGet<{ stats: Record<string, unknown> }>(`${BASE}/stats`),

  exportData: (index?: string, query?: string) =>
    apiGet<{ data: unknown[] }>(`${BASE}/export?index=${index || "all"}&query=${query || ""}`),

  getFacets: (q: string, type?: string) => {
    const searchParams = new URLSearchParams();
    searchParams.set("q", q);
    if (type) searchParams.set("type", type);
    return apiGet<{ facets: Record<string, Record<string, number>> }>(`${BASE}/facets?${searchParams.toString()}`);
  },

  saveSearch: (name: string, query: string, filters?: Record<string, string>) =>
    apiPost<{ search: Record<string, unknown> }>(`${BASE}/saved`, { name, query, filters }),

  getSavedSearches: () => apiGet<{ searches: Record<string, unknown>[] }>(`${BASE}/saved`),

  deleteSavedSearch: (id: string) => apiDelete<{ message: string }>(`${BASE}/saved/${id}`),

  getHistory: () => apiGet<{ history: Array<{ query: string; timestamp: string }> }>(`${BASE}/history`),

  getRecommendations: () => apiGet<{ recommendations: Record<string, unknown>[] }>(`${BASE}/recommendations`),
};
